import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import * as styles from './styles.css';
import { ArticleHeading2 } from '@cian/ui-kit';

interface IGenplanProps {
  image: string;
  onShow(): void;
  renderHouses(containerWidth: number, containerHeight: number): React.ReactNode;
}

export function Genplan({ image, onShow, renderHouses, children }: React.PropsWithChildren<IGenplanProps>) {
  const imageRef = React.useRef<HTMLImageElement | null>(null);
  const [loaded, setLoaded] = React.useState(false);
  const [{ width, height }, setImageSize] = React.useState({ width: 0, height: 0 });

  const handleImageLoaded = React.useCallback(() => {
    const img = imageRef.current;

    /* istanbul ignore else */
    if (img) {
      setLoaded(true);
      setImageSize({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    }
  }, []);

  React.useEffect(() => {
    /* istanbul ignore else */
    if (imageRef.current && imageRef.current.complete) {
      handleImageLoaded();
    }
  }, [handleImageLoaded]);

  return (
    <ActionAfterViewed callback={onShow}>
      <div data-nav-tab="map/Генплан" id="map" className={styles['nav_container']}>
        <div className={styles['title']}>
          <ArticleHeading2>Генплан</ArticleHeading2>
        </div>
        <div className={styles['container']}>
          <img ref={imageRef} src={image} onLoad={handleImageLoaded} />
          {/* eslint-disable-next-line react/forbid-elements */}
          <svg id="genplan-svg" width="100%" height="100%" viewBox={`0 0 ${width} ${height}`} />
          {loaded && renderHouses(width, height)}
          {children}
        </div>
      </div>
    </ActionAfterViewed>
  );
}
